<template>
  <tr>
    <td>
       {{format(item.dataCadastro)}}
    </td>
    <td>
      {{item.content.nomeCliente}}
    </td>
    <td>
      {{item.content.emailCliente}}
    </td>
    <td>
      {{item.content.nomeCampanha}}
    </td>
    <td>
      {{enviado}}
    </td>
    <td>
        <v-icon size="20"
                slot="activator"
                v-tooltip="'Erros'"
                v-if="item.logs && item.logs.length > 0"
                @click="errors">mdi-eye</v-icon>


    </td>
  </tr>
</template>

<script>
    import EventBus from '@packages/event-bus'
    import moment from 'moment'
    export default {
        components: {
        },

        props: {
            dataItem: {
                type: Object,
                required: true,
            }
        },

        data() {
            return {
                pendingRemoveId: null
            }
        },

        computed: {
            item() {
                return this.dataItem
            },
            enviado(){
                return !this.item.enviar ? 'Sim' : 'Não'
            }
        },

        methods:{
            format(date){
               return moment(date).format('DD/MM/YYYY - HH:mm')
            },
            errors(){
                EventBus.$emit('RESET_REPORT_ERRORS_INTEGRATION', JSON.parse(JSON.stringify(this.item)))
            }

        }
    }
</script>

<style lang="scss" scoped>
@import "~@variables";

.edit {
  .mdi {
    font-size: 18px;

    &:not(:last-child) {
      margin-right: 6px;
    }
  }
}

.icon-green {
  color: $primary;
}
</style>
